import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { Constants } from "@constants";
import { CuoteoDatosDTO, CuoteoResultadoDTO, ICuoteoResultadoDTO } from "@DTOS";
import { Nilable } from "@shared/utils";

@Injectable({
    providedIn: "root"
})
export class CuotasServiceBackend {

    constructor(private httpClient: HttpClient) {}

    public startQuote(datosCuoteo: CuoteoDatosDTO): Observable<Nilable<CuoteoResultadoDTO>> {
        return this.httpClient.post<ICuoteoResultadoDTO>(`${Constants.apiURL}/quotas/quote`, datosCuoteo.toJSON())
            .pipe(
                map(response => new CuoteoResultadoDTO(response)),
                catchError(() => of(null))
            );
    }

    public filterCases(datasetCSV: string, filtrarPor: any[]): Observable<Blob> {
        return this.httpClient.post(`${Constants.apiURL}/quotas/filter_cases`, {
            dataset: datasetCSV,
            filter_by: filtrarPor
        }, { responseType: "arraybuffer" })
            .pipe(
                map(data => new Blob([data], { type: "text/csv;charset=utf-8" }))
            );
    }

    public showDuplicates(datasetCSV: string, columnas: string[]): Observable<any> {
        return this.httpClient.post(`${Constants.apiURL}/quotas/check_duplicated_cases`, {
            dataset: datasetCSV,
            columns_duplicates: columnas
        }).pipe(
            map(response => response),
            catchError(() => of(null))
        );
    }

    public deleteDuplicates(datasetCSV: string, columnas: string[]): Observable<Blob> {
        return this.httpClient.post(`${Constants.apiURL}/quotas/delete_duplicates_cases`, {
            dataset: datasetCSV,
            columns_duplicates: columnas
        }, { responseType: "arraybuffer" })
            .pipe(
                map(data => new Blob([data], { type: "text/csv;charset=utf-8" }))
            );
    }
}
